export const DEFAULT_REQUEST_TIMEOUT = 200;
